/* el-clinician-reviews.js — sections/el-clinician-reviews.liquid
   1. Desktop: the widget is scaled down, so its frame is given the scaled height.
   2. Optional "See all" button removes the fade. */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 1024px)');

  function fit(frame) {
    var iframe = frame.querySelector('iframe');
    if (!iframe) return;
    if (!desktop.matches) { frame.style.height = ''; return; }
    var scale = parseFloat(getComputedStyle(frame).getPropertyValue('--el-cr-scale')) || 1;
    frame.style.height = Math.ceil(iframe.offsetHeight * scale) + 'px';
  }

  function init(root) {
    (root || document).querySelectorAll('[data-el-clinician-frame]').forEach(function (frame) {
      if (frame.dataset.elReady) return;
      frame.dataset.elReady = '1';
      var iframe = frame.querySelector('iframe');
      fit(frame);
      if (window.ResizeObserver && iframe) new ResizeObserver(function () { fit(frame); }).observe(iframe);
      /* FrontrowMD sets the height with an inline style */
      if (window.MutationObserver && iframe) new MutationObserver(function () { fit(frame); }).observe(iframe, { attributes: true, attributeFilter: ['style', 'height'] });
      desktop.addEventListener && desktop.addEventListener('change', function () { fit(frame); });
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-el-clinician-expand]');
    if (!button) return;
    var section = button.closest('[data-el-clinician-reviews]');
    if (!section) return;
    section.classList.add('is-expanded');
    button.setAttribute('aria-expanded', 'true');
  });
})();
